import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import teamSliceReducer from "../features/team/teamSlice";
import projectsSliceReducer from "../features/projects/projectsSlice";
import tasksSliceReducer from "../features/tasks/tasksSlice";
import filterSliceReducer from "../features/filter/filterSlice";


export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    team: teamSliceReducer,
    projects: projectsSliceReducer,
    tasks: tasksSliceReducer,
    filter: filterSliceReducer
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(apiSlice.middleware),
});
